import { render } from "./viewBooking.vue?vue&type=template&id=2794c4ce&scoped=true"
import script from "./viewBooking.vue?vue&type=script&lang=js"
export * from "./viewBooking.vue?vue&type=script&lang=js"

import "./viewBooking.vue?vue&type=style&index=0&id=2794c4ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2794c4ce"]])

export default __exports__